import React, { PropTypes, Component } from 'react'
import { Field } from 'react-redux-form/immutable'

import errBlock from 'components/ErrBlock'

class Input extends Component {

  componentDidMount() {
    if (this.props.autoFocus) {
      setTimeout(() => {
        this._input.select()
      }, 100)
    }
  }

  render() {
    const { model, type, label, required, ...props } = this.props

    return (
      <Field model={model}>
        <label htmlFor={label}>{label} {required && <span className="req">*</span>}</label>
        <input
          type={type}
          className="form-control"
          ref={(c) => this._input = c}
          {...props}
        />
        {errBlock(model)}
      </Field>
    )
  }
}

Input.propTypes = {
  model: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  autoFocus: PropTypes.bool,
}

Input.defaultProps = {
  type: 'text',
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Input/index.js